import {
  Badge,
  Button,
  CssBaseline,
  Grid,
  IconButton,
  Paper,
  Snackbar,
  Tooltip,
  useMediaQuery,
  useTheme,
  Box
} from "@mui/material";
import { Alert } from "@mui/lab";
import {
  getGridStringOperators,
  GridFilterPanel,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  LicenseInfo,
  DataGridPro,
  getGridDateOperators
} from "@mui/x-data-grid-pro";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { GlobalEdiApiConstants } from "../../Constants/GlobalEdiApiConstants";
import { ModuleAccessPermissionKey } from "../../Constants/ModuleAccessKey";
import useStyles from "../common/CommonStyle/CommonStyle";
import CustomBreadCrumb from "../common/CustomBreadCrumb";
import GridTextLocalization from "../common/GridTextLocalization/GridTextLocalization";
import { LoggedInUserDetails } from "../common/LoggedInUserDetails/LoggedInUserDetails";
import { SupportedLanguageDetails } from "../common/SupportedLanguageDetails/SupportedLanguageDetails";
import { Controller, set, useForm } from "react-hook-form";
import ChipInfoList from "../common/ChipInfoList";
import { CommonService } from "../../services";
import CommonGridPagination from "../common/CommonGridPagination/CommonGridPagination";
import RefreshIcon from "@mui/icons-material/Refresh";
import _ from "lodash/fp";
import { CustomFilters } from "../common/CustomFilters/CustomFilters";
import saveAs from "file-saver";
import { useHistory } from "react-router-dom";
import ExcelIcon from "../PoTransmission/ExcelIcon.svg";
import CommonBackDrop from "../common/BackDrop";
import { FilterList } from "@mui/icons-material";
import CustomFilterComponent, {
  GetFilterableColumns
} from "../common/CustomFilterComponent";
import { manageUserPreferences } from "../../services/manageUserPreferences";
import POPDFApprovalIcon from "@mui/icons-material/AssignmentTurnedIn";
import IconMessage from "@mui/icons-material/Forum";
import PoTransmissionHdrDrpDn from "./PoTransmissionHdrDrpDn/PoTransmissionHdrDrpDn";

const columnFieldsName = {
  poNumber: "poNumber",
  bpCode: "bpCode",
  generatedDate: "createdDate",
  approved: "approved",
  approvedBy: "approvedBy",
  approvedDate: "approvedDate",
  generatedFromDt: "generatedFromDt",
  generatedToDt: "generatedToDt",
  appremailSent: "apprEmailSent",
  bpName: "bpName",
  entityName: "entity.entityName",
  msgStatusFlag: "msgStatusFlag",
  // emailTo: "bpEmailMessageConfig.emailTo",
  msgStatusRemarks: "msgStatusRemarks",
  erpEntityCode: "entity.erpEntityCode",
  createdTime: "updatedTime",
  emailSentDate: "emailSentDate",
  rejectionFlag: "rejectionFlag",
  // resendRequestedBy: "resendRequestedBy",
  // resendRequestedTime: "resendRequestedTime",
  ackStatusFlag: "ackStatusFlag",
  fileName: "fileName",
  totalFileCount: "totalFileCount",
  poTransmissionHdrId: "poTransmissionHdrId",
  remarks: "remarks"
};

const PoTransmissionHdr = props => {
  const classes = useStyles();
  const intl = useIntl();
  const history = useHistory();
  const theme = useTheme();
  const X_GRID_LICENSE_KEY = `${process.env.REACT_APP_X_GRID_LICENSE_KEY}`.toString();
  LicenseInfo.setLicenseKey(X_GRID_LICENSE_KEY);
  const moduleAccessKeyPermission = ModuleAccessPermissionKey();
  const { loggedInUserInfo } = useContext(LoggedInUserDetails);
  const poTransmissionModuleAccess =
    loggedInUserInfo.roleModuleAccess[moduleAccessKeyPermission.poTransmission];
  const selectedLanguage = useContext(SupportedLanguageDetails);
  const localtext = GridTextLocalization();
  const apiUrlAndParamBodyConstants = GlobalEdiApiConstants();
  const mobileScreen = useMediaQuery(theme.breakpoints.down("md"));

  const pageLabelsConstantsAndMessages = {
    alignment: {
      alignLeft: "left",
      alignRight: "right",
      alignCenter: "center"
    }
  };

  const [alertBoxState, setAlertBoxState] = React.useState({
    openAlert: false,
    vertical: "top",
    horizontal: "center",
    message: "",
    severity: ""
  });
  const handleCloseAlert = () => {
    setAlertBoxState({ ...alertBoxState, openAlert: false });
  };
  const { vertical, horizontal, openAlert, message, severity } = alertBoxState;
  const [tableLoadingStatus, setTableLoadingStatus] = useState(false);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [refreshTable, setRefreshTable] = useState(false);
  const [searchedGeneratedFromDt, setSearchedGeneratedFromDt] = useState(null);
  const [searchedGeneratedToDt, setSearchedGeneratedToDt] = useState(null);
  const [selectedRow, setSelectedRow] = React.useState([]);
  const [disableApproveButton, isDisableApproveButton] = useState(true);
  const [disableResendButton, isDisableResendButton] = useState(true);
  const [disableRejectionButton, isDisableRejectionButton] = useState(true);
  const [searchedApprovedRecords, setSearchedApprovedRecords] = useState("");
  const [searchedEmailStatusRecords, setSearchedEmailStatusRecords] = useState(
    true
  );
  const [searchedBpCode, setSearchedBpCode] = useState("");
  const [searchedApprovedBy, setSearchedApprovedBy] = useState("");
  const [searchedRemarks, setSearchedRemarks] = useState("");
  const [searchedPoNo, setSearchedPoNo] = useState("");
  const [
    disiablingDownloadButtonForZeroRecords,
    setDisiablingDownloadButtonForZeroRecords
  ] = useState(false);
  const [keyValueData, setKeyValueData] = useState("");
  const [openBackDrop, setOpenBackDrop] = useState(false);
  var defaultEntity = loggedInUserInfo.defaultEntity;
  const [searchedErpEntityCode, setSearchedErpEntityCode] = useState(
    defaultEntity
  );
  const [searchedBpName, setSearchedBpName] = useState("");
  const [searchedEmailStatus, setSearchedEmailStatus] = useState("");
  const [openFilterPanel, setFilterPanel] = useState(false);
  const [searchedAckStatus, setSearchedAckStatus] = useState(true);
  const handleClose = () => {
    setFilterPanel(false);
  };
  const [filterCount, setFilterCount] = React.useState(0);
  const [chipInfoList, setChipInfoList] = useState([]);

  const componentList = [
    {
      path: undefined,
      name: <FormattedMessage id="common.menu.breadcrumb.message" />,
      iconName: IconMessage
    },
    {
      path: "/poTransmissionHdr",
      name: <FormattedMessage id="common.module.breadcrumb.poTransmission" />,
      iconName: POPDFApprovalIcon
    }
  ];

  const defaulSelectedFilters =
    defaultEntity !== ""
      ? [
          {
            columnField: columnFieldsName.erpEntityCode,
            headerName: "Ent. Code",
            id: 0,
            operatorValue: "contains",
            value: defaultEntity
          }
        ]
      : [];

  const [selectedFilters, setSelectedFilters] = useState(defaulSelectedFilters);

  const [
    isIntialDefaultEntityFilter,
    setIsIntialDefaultEntityFilter
  ] = useState(defaultEntity !== "" ? true : false);

  const {
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue
  } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      process: "",
      createdDate: "",
      generatedFromDt: "",
      generatedToDt: "",
      approved: ""
    }
  });

  const [paramBody, setParamBody] = useState({
    body: {
      entity: {
        erpEntityCode: ""
      },
      organization: {
        erpOrgCode: null
      },
      bpCode: "",
      filePath: "",
      poNumber: "",
      approvedBy: "",
      createdDate: "",
      approved: "",
      apprEmailSent: true,
      recordApprovedStatus: "All",
      recordApprSentStatus: "All",
      recordEmailSentDate: "All",
      recordErrorStatus: "All"
    },
    pageNo: 0,
    sortDir: "desc",
    sortKey: "createdDate",
    recordsPerPage: 25
  });

  const insert = (arr, index, newItems) => [
    ...arr.slice(0, index),
    newItems,
    ...arr.slice(index)
  ];

  const [
    callSaveApiForOrderVisibility,
    setCallSaveApiForOrderVisibility
  ] = useState(false);
  const [callSaveApiForSorting, setCallSaveApiForSorting] = useState(false);
  const [preference, setPreference] = useState(
    apiUrlAndParamBodyConstants.paramBodyForGetListApis.userPreference
  );
  const [pinnedColumns, setPinnedColumns] = useState({
    left: ["__check__"],
    right: []
  });
  const [callSaveApiForPinning, setCallSaveApiForPinning] = useState(false);
  const [callSaveApiForFilter, setCallSaveApiForFilter] = useState(false);
  const [intialParamBodyApiCall, setIntialParamBodyApiCall] = useState(false);
  const disableAuthorizationBasedOnTheRoleAccess =
    poTransmissionModuleAccess !== undefined
      ? poTransmissionModuleAccess.createFlag ||
        poTransmissionModuleAccess.editFlag
      : false;

  function orderAndHideColumns(savedUserPreference, defaultUserPreference) {
    if (
      savedUserPreference.length !== 0 &&
      defaultUserPreference.length !== 0
    ) {
      var orderedUserPreferences = [],
        len = defaultUserPreference.length,
        len_copy = len,
        index,
        current;

      for (; len--; ) {
        current = defaultUserPreference[len];
        index = savedUserPreference.findIndex(
          element => element.field === current.field
        );
        orderedUserPreferences[index] = current;
        orderedUserPreferences[index].hide = savedUserPreference[index].hide;
      }

      Array.prototype.splice.apply(
        defaultUserPreference,
        [0, len_copy].concat(orderedUserPreferences)
      );
      return orderedUserPreferences;
    }
  }

  const savePreference = (preferenceChangeIn, params, orderedColumns) => {
    if (preferenceChangeIn === "filter") {
      setCallSaveApiForFilter(true);
      setPreference(prev => ({ ...prev, columnsFilter: params }));
    } else if (preferenceChangeIn === "sort") {
      setCallSaveApiForSorting(true);
      setPreference(prev => ({
        ...prev,
        columnsSort: { field: params.field, sort: params.sort }
      }));
    } else if (
      preferenceChangeIn === "visibility" ||
      preferenceChangeIn === "order"
    ) {
      var splicedFirstColumn = params;
      if (params[0].field === "__check__")
        splicedFirstColumn = params.splice(1, params.length);
      setCallSaveApiForOrderVisibility(true);
      setPreference(prev => ({
        ...prev,
        columnsOrdervisible: splicedFirstColumn
      }));
    } else if (preferenceChangeIn === "pinned") {
      setCallSaveApiForPinning(true);
      setPreference(prev => ({
        ...prev,
        columnsOrdervisible: orderedColumns,
        columnsPinned: params
      }));
    }
  };

  useEffect(() => {
    manageUserPreferences
      .saveLastOpenedScreen(componentList[1].name.props.id)
      .then(response => {})
      .catch(function(error) {
        if (error.response !== undefined) {
          setAlertBoxState({
            ...alertBoxState,
            openAlert: true,
            message: error.response.data.message,
            severity: "error"
          });
        }
      });
  }, []);

  useEffect(() => {
    if (callSaveApiForPinning === false)
      preference.columnsPinned = pinnedColumns;
    if (callSaveApiForFilter === false)
      preference.columnsFilter = selectedFilters;
    if (
      callSaveApiForOrderVisibility === false &&
      callSaveApiForPinning === false
    )
      preference.columnsOrdervisible = columns;
    if (callSaveApiForSorting === false)
      preference.columnsSort = {
        field: paramBody.sortKey,
        sort: paramBody.sortDir
      };
    if (
      (callSaveApiForFilter === true ||
        callSaveApiForPinning === true ||
        callSaveApiForOrderVisibility === true ||
        callSaveApiForSorting === true) &&
      (preference.columnsOrdervisible !== undefined &&
        preference.columnsOrdervisible !== null &&
        preference.columnsOrdervisible.length !== 0 &&
        preference.columnsSort.field !== "")
    ) {
      manageUserPreferences
        .saveGridPreferences({
          userId: 0,
          organization: {},
          entity: {},
          screenName: componentList[1].name.props.id,
          tabName: componentList[1].name.props.id,
          preferences: JSON.stringify(preference),
          lastOpen: true
        })
        .then(response => {
          if (callSaveApiForOrderVisibility === true) {
            var defaultColumns = columns;
            var userChangedColumns = preference.columnsOrdervisible;
            var userPreferedColumns = orderAndHideColumns(
              userChangedColumns,
              defaultColumns
            );
            setColumns(userPreferedColumns);
            setCallSaveApiForOrderVisibility(false);
          } else if (callSaveApiForSorting === true) {
            setCallSaveApiForSorting(false);
          } else if (callSaveApiForPinning === true) {
            setPinnedColumns(preference.columnsPinned);
            setColumns(preference.columnsOrdervisible);
            setCallSaveApiForPinning(false);
          } else if (callSaveApiForFilter === true) {
            setCallSaveApiForFilter(false);
          }
        })
        .catch(function(error) {
          if (error.response !== undefined) {
            setAlertBoxState({
              ...alertBoxState,
              openAlert: true,
              message: error.response.data.message,
              severity: "error"
            });
          }
        });
    }
  }, [preference]);

  const getDetailPanelHeight = React.useCallback(() => 10, []);
  const getDetailPanelContent = React.useCallback(
    ({ row }) => (
      <Box sx={{ p: 1 }} key={row.poTransmissionHdrId}>
        {
          <PoTransmissionHdrDrpDn
            poTransmissionHdrId={row.poTransmissionHdrId}
          />
        }
      </Box>
    ),
    []
  );

  const commonColumnForPoTransmission = [
    {
      field: "file",
      headerName: intl.formatMessage({ id: "columnname.file.label" }),
      width: 100,
      sortable: false,
      hide: false,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: cellParams => (
        <div>
          {cellParams.row.downloadCsvFilePath !== null && (
            <Tooltip
              title={
                <FormattedMessage
                  id="common.tooltip.breadcrumb.downloadExcel"
                  defaultMessage="downloadExcel"
                />
              }
              placement="bottom"
              className={classes.actionButton}
              onClick={() => {
                showDownloadExcel(cellParams.row.downloadCsvFilePath);
              }}
            >
              <span>
                <IconButton className={classes.customeToolbar} size="large">
                  <img
                    icon
                    src={ExcelIcon}
                    className={classes.ExcelIconPO}
                    alt="ExcelIcon"
                    color="primary"
                    size="10"
                  />
                </IconButton>
              </span>
            </Tooltip>
          )}
        </div>
      )
    },
    {
      field: columnFieldsName.entityName,
      headerName: intl.formatMessage({ id: "common.EntityName.label" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 190,
      sortable: true,
      type: "string",
      hide: true,
      filterable: false,
      valueGetter: params => `${params.row.entity.entityName}`,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.erpEntityCode,
      headerName: intl.formatMessage({ id: "columnname.entitycode.label" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 85,
      sortable: false,
      type: "string",
      hide: false,
      filterable: true,
      valueGetter: params => `${params.row.entity.erpEntityCode}`,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.bpCode,
      width: 130,
      headerName: intl.formatMessage({
        id: "common.textfield.columname.bpcode"
      }),
      sortable: true,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      type: "string",
      hide: false,
      filterable: true,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.bpName,
      headerName: intl.formatMessage({ id: "columnName.bpname.label" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 300,
      sortable: false,
      type: "string",
      hide: false,
      filterable: true,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.approved,
      width: 150,
      headerName: intl.formatMessage({ id: "columnName.approved.label" }),
      sortable: false,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      type: "string",
      hide: true,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: CommonService.ApproveFailureChipsForPO
    },
    {
      field: columnFieldsName.totalFileCount,
      width: 170,
      headerName: intl.formatMessage({
        id: "columnname.totalFileCount.label"
      }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      sortable: false,
      type: "string",
      hide: false,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.msgStatusFlag,
      headerName: intl.formatMessage({ id: "columnname.emailstatus.label" }),
      width: 155,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      sortable: true,
      type: "string",
      filterable: true,
      hide: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: CommonService.SuccessFailureChipsForPoTransmission
    },
    {
      field: columnFieldsName.msgStatusRemarks,
      headerName: intl.formatMessage({
        id: "columnName.msgSentStatusRemarks.label"
      }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 500,
      sortable: false,
      type: "string",
      hide: true,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.generatedDate,
      width: 200,
      headerName: intl.formatMessage({
        id: "columnname.columnnamePOFileRcvDate.label"
      }),
      sortable: true,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      type: "string",
      hide: false,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: cellParams => <span>{cellParams.row.createdDtDisp}</span>
    },
    {
      field: columnFieldsName.remarks,
      headerName: intl.formatMessage({ id: "columnname.remarks.label" }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      width: 500,
      sortable: false,
      type: "string",
      hide: true,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.emailSentDate,
      width: 175,
      headerName: intl.formatMessage({ id: "columnName.emailSentDate.label" }),
      sortable: true,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      type: "string",
      hide: false,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: cellParams => <span>{cellParams.row.emailSentDtDisp}</span>
    },
    {
      field: columnFieldsName.generatedFromDt,
      width: 0,
      headerName: intl.formatMessage({ id: "textfield.fromdate.label" }),
      sortable: true,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      type: "string",
      hide: true,
      filterable: true,
      hideable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: "generatedToDt",
      width: 0,
      headerName: intl.formatMessage({ id: "textfield.todate.label" }),
      sortable: true,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      type: "string",
      hide: true,
      filterable: true,
      hideable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    // {
    //   field: columnFieldsName.rejectionFlag,
    //   headerName: intl.formatMessage({ id: "common.rejectionRemark.label" }),
    //   headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
    //   align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
    //   width: 190,
    //   sortable: true,
    //   type: "string",
    //   hide: true,
    //   filterable: false,
    //   valueGetter: params => `${params.row.rejectionRemark}`,
    //   renderHeader: CommonService.customRenderHeaderColumns
    // },
    // {
    //   field: columnFieldsName.resendRequestedBy,
    //   headerName: intl.formatMessage({ id: "common.resendrequestedby.label" }),
    //   width: 190,
    //   sortable: true,
    //   headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
    //   align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
    //   type: "string",
    //   hide: false,
    //   filterable: false,
    //   renderHeader: CommonService.customRenderHeaderColumns
    // },
    // {
    //   field: columnFieldsName.resendRequestedTime,
    //   headerName: intl.formatMessage({
    //     id: "common.resendrequestedtime.label"
    //   }),
    //   sortable: true,
    //   headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
    //   align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
    //   type: "string",
    //   hide: false,
    //   filterable: false,
    //   renderHeader: CommonService.customRenderHeaderColumns,
    //   renderCell: cellParams => (
    //     <span>{cellParams.row.resendRequestedDtDisp}</span>
    //   )
    // },
    {
      field: columnFieldsName.ackStatusFlag,
      headerName: intl.formatMessage({
        id: "columnname.acknowledgementstatus.label"
      }),
      width: 155,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      sortable: true,
      type: "string",
      filterable: false,
      hide: false,
      renderHeader: CommonService.customRenderHeaderColumns,
      renderCell: CommonService.AckFlagChipsForPoTransmission
    },
    {
      field: columnFieldsName.fileName,
      width: 170,
      headerName: intl.formatMessage({
        id: "columnname.poFileName.label"
      }),
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      sortable: false,
      type: "string",
      hide: true,
      filterable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    },
    {
      field: columnFieldsName.poNumber,
      width: 130,
      headerName: intl.formatMessage({ id: "columnname.pono.label" }),
      sortable: true,
      headerAlign: `${pageLabelsConstantsAndMessages.alignment.alignCenter}`,
      align: `${pageLabelsConstantsAndMessages.alignment.alignLeft}`,
      type: "string",
      hide: true,
      filterable: true,
      hideable: false,
      renderHeader: CommonService.customRenderHeaderColumns
    }
  ];

  const [columns, setColumns] = useState([]);
  useEffect(() => {
    setIntialParamBodyApiCall(false);
    setTableLoadingStatus(true);
    manageUserPreferences
      .loadUserPreferences({
        body: {
          screenName: componentList[1].name.props.id,
          tabName: componentList[1].name.props.id,
          userId: 0,
          organization: {},
          entity: {}
        }
      })
      .then(response => {
        setIntialParamBodyApiCall(true);
        if (response.data === null) {
          setColumns(commonColumnForPoTransmission);
          savePreference("visibility", commonColumnForPoTransmission);
          paramBody.body.entity.erpEntityCode = defaultEntity;
          setParamBody({ ...paramBody });
        }
        //preference present in db
        else {
          var savedColumnsInResponse = JSON.parse(response.data.preferences);
          var orderedColumns = orderAndHideColumns(
            savedColumnsInResponse.columnsOrdervisible,
            commonColumnForPoTransmission
          );
          setPinnedColumns(savedColumnsInResponse.columnsPinned);
          setColumns(orderedColumns);

          let bpName = null;
          let bpCode = null;
          let entityCode = null;
          let entityName = null;
          let msgStatusFlag = null;
          let poNumber = null;
          let msgStatusRemarks = null;
          let approvedBy = null;
          let approved = null;
          let generatedFromDt = null;
          let generatedToDt = null;
          let ackStatusFlag = null;
          savedColumnsInResponse.columnsFilter.map(columns => {
            switch (columns.columnField) {
              // case "bpName":
              //   bpName = columns.value;
              //   break;
              case "msgStatusRemarks":
                msgStatusRemarks = columns.value;
                break;
              case "poNumber":
                poNumber = columns.value;
                break;
              case "msgStatusFlag":
                msgStatusFlag = columns.value;
                break;
              case "bpCode":
                bpCode = columns.value;
                break;
              case "approvedBy":
                approvedBy = columns.value;
                break;
              case "approved":
                approved = columns.value;
                break;
              case "generatedFromDt":
                generatedFromDt = columns.value;
                break;
              case "generatedToDt":
                generatedToDt = columns.value;
                break;
              case "entity.erpEntityCode":
                entityCode = columns.value;
                break;
              case "ackStatusFlag":
                ackStatusFlag = columns.value;
                break;
            }
          });

          setSearchedApprovedRecords(approved);
          setSearchedBpCode(bpCode);
          setSearchedApprovedBy(approvedBy);
          setSearchedRemarks(msgStatusRemarks);
          setSearchedPoNo(poNumber);
          setSearchedErpEntityCode(entityCode);
          setSearchedBpName(bpName);
          setSearchedEmailStatus(msgStatusFlag);
          setSearchedGeneratedFromDt(generatedFromDt);
          setSearchedGeneratedToDt(generatedToDt);
          setSearchedAckStatus(ackStatusFlag);
          var filterBody = {
            entity: {
              erpEntityCode: entityCode
            },
            msgStatusRemarks: msgStatusRemarks,
            bpCode: bpCode,
            // bpName: bpName,
            poNumber: poNumber,
            msgStatusFlag:
              msgStatusFlag === "Not Sent"
                ? 0
                : msgStatusFlag === "Pending"
                ? 1
                : msgStatusFlag === "Successfully Sent"
                ? 2
                : msgStatusFlag === "Failed to Send"
                ? 3
                : msgStatusFlag === "Cancelled"
                ? 4
                : msgStatusFlag === "In-Queue"
                ? 6
                : msgStatusFlag === "In Progress"
                ? 7
                : "",
            createdDate: "",
            approvedBy: approvedBy,
            approved:
              approved === ""
                ? "All"
                : approved === "Not Approved"
                ? 0
                : approved === "Approved"
                ? 1
                : approved === "Rejected"
                ? 2
                : "",
            apprEmailSent: true,
            recordApprovedStatus:
              approved === ""
                ? "All"
                : approved === "Not Approved"
                ? 0
                : approved === "Approved"
                ? 1
                : approved === "Rejected"
                ? 2
                : "All",
            recordApprSentStatus: "",
            recordEmailSentDate:
              searchedEmailStatusRecords === "EMAIL SENT"
                ? true
                : searchedEmailStatusRecords === "EMAIL NOT SENT"
                ? false
                : "",
            recordErrorStatus:
              msgStatusFlag === ""
                ? "All"
                : msgStatusFlag === "Not Sent"
                ? 0
                : msgStatusFlag === "Pending"
                ? 1
                : msgStatusFlag === "Successfully Sent"
                ? 2
                : msgStatusFlag === "Failed to Send"
                ? 3
                : msgStatusFlag === "Cancelled"
                ? 4
                : msgStatusFlag === "In-Queue"
                ? 6
                : msgStatusFlag === "In Progress"
                ? 7
                : "All",
            generatedFromDt: generatedFromDt,
            generatedToDt: generatedToDt,
            ackStatusFlag:
              ackStatusFlag === "Not Sent"
                ? 0
                : ackStatusFlag === "Pending"
                ? 1
                : ackStatusFlag === "In-Progress"
                ? 2
                : ackStatusFlag === "Successfully sent"
                ? 3
                : ""
          };
          paramBody.body = filterBody;
          //default entity filter on no user preferences  filters in db
          if (savedColumnsInResponse.columnsFilter.length <= 0)
            paramBody.body.entity.erpEntityCode = defaultEntity;
          paramBody.sortDir = savedColumnsInResponse.columnsSort.sort;
          paramBody.sortKey = savedColumnsInResponse.columnsSort.field;
          setParamBody({ ...paramBody });

          if (savedColumnsInResponse.columnsFilter.length > 0)
            setSelectedFilters(savedColumnsInResponse.columnsFilter);
        }
      })
      .catch(function(error) {
        setTableLoadingStatus(false);
        setIntialParamBodyApiCall(true);
        if (error.response !== undefined) {
          setAlertBoxState({
            ...alertBoxState,
            openAlert: true,
            message: error.response.data.message,
            severity: "error"
          });
        }
      });
  }, [selectedLanguage]);

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (intialParamBodyApiCall) {
      setTableLoadingStatus(true);
      setTableData([]);
      CommonService.GetListApi("/poTransmissionHdr", paramBody)
        .then(response => {
          setTotalRowCount(response.data.totalElements);
          setTableLoadingStatus(false);
          setTableData(response.data.content);
          console.log(response.data.content);
          response.data.totalElements > 0
            ? setChipInfoList(
                response.data.content[0].headerChipList === null
                  ? []
                  : response.data.content[0].headerChipList
              )
            : setChipInfoList([]);
        })
        .catch(function(error) {
          setTableLoadingStatus(false);
          if (error.response !== undefined) {
            setAlertBoxState({
              ...alertBoxState,
              openAlert: true,
              message: error.response.data.message,
              severity: "error"
            });
          }
        });
    }
  }, [paramBody, refreshTable]);

  useEffect(() => {
    if (totalRowCount === 0) {
      setDisiablingDownloadButtonForZeroRecords(true);
    } else {
      setDisiablingDownloadButtonForZeroRecords(false);
    }
  }, [totalRowCount]);

  const approveAndPoTransmissionHdrId = tableData.map(row => {
    return {
      approved: row.approved,
      poTransmissionHdrId: row.poTransmissionHdrId,
      msgStatusFlag: row.msgStatusFlag
      // ackStatusFlag: row.ackStatusFlag
    };
  });

  const filterValueLoad = approveAndPoTransmissionHdrId.filter(item => {
    if (selectedRow.includes(item.poTransmissionHdrId)) {
      return item;
    }
  });

  const filterValueApproved = filterValueLoad.map(row => {
    return row.approved;
  });
  const filterValueStatusFlag = filterValueLoad.map(row => {
    return row.msgStatusFlag;
  });
  // const filterValueAckStatusFlag = filterValueLoad.map(row => {
  //   return row.ackStatusFlag;
  // });
  function currentlySelectedRow(selections) {
    setSelectedRow(selections);
    if (selections.length === 0) {
      isDisableApproveButton(true);
      isDisableResendButton(true);
      isDisableRejectionButton(true);
    }
  }

  useEffect(() => {
    if (selectedRow.length === 0) {
      isDisableApproveButton(true);
      isDisableResendButton(true);
      isDisableRejectionButton(true);
    } else if (filterValueApproved.toString() === "0") {
      isDisableApproveButton(false);
      isDisableRejectionButton(false);
      isDisableResendButton(true);
    } else if (filterValueApproved.toString() === "1") {
      isDisableApproveButton(true);
      isDisableResendButton(false);
      isDisableRejectionButton(
        filterValueStatusFlag.toString() === "3" ? false : true
      );
    } else if (filterValueApproved.toString() === "2") {
      isDisableApproveButton(false);
      isDisableResendButton(true);
      isDisableRejectionButton(true);
    } else {
      isDisableApproveButton(false);
      isDisableResendButton(false);
      isDisableRejectionButton(false);
    }
  }, [filterValueApproved]);

  if (columns.length > 0) {
    const approvedColumn = columns.find(
      column => column.field === columnFieldsName.approved
    );
    const approvedColIndex = columns.findIndex(
      col => col.field === columnFieldsName.approved
    );

    const approvedFilterOperators = getGridStringOperators().map(operator => ({
      ...operator,
      InputComponent: CustomFilters.ApprovedPOInputValue
    }));

    columns[approvedColIndex] = {
      ...approvedColumn,
      filterOperators: approvedFilterOperators
    };

    const entityCodeColumn = columns.find(
      column => column.field === columnFieldsName.erpEntityCode
    );
    const entityCodeColIndex = columns.findIndex(
      col => col.field === columnFieldsName.erpEntityCode
    );

    const entityCodeFilterOperators = getGridStringOperators().map(
      operator => ({
        ...operator,
        InputComponent: CustomFilters.EntityCodeInputValue
      })
    );

    columns[entityCodeColIndex] = {
      ...entityCodeColumn,
      filterOperators: entityCodeFilterOperators
    };

    const emailStatusColumn = columns.find(
      column => column.field === columnFieldsName.msgStatusFlag
    );
    const emailStatusColIndex = columns.findIndex(
      col => col.field === columnFieldsName.msgStatusFlag
    );

    const emailStatusFilterOperators = getGridStringOperators().map(
      operator => ({
        ...operator,
        InputComponent: CustomFilters.EmailStatusForPoTransmissionValue
      })
    );

    columns[emailStatusColIndex] = {
      ...emailStatusColumn,
      filterOperators: emailStatusFilterOperators
    };

    const generatedFromDtColumn = columns.find(
      column => column.field === columnFieldsName.generatedFromDt
    );
    const generatedFromDtColIndex = columns.findIndex(
      col => col.field === columnFieldsName.generatedFromDt
    );

    const generatedFromDtFilterOperators = getGridDateOperators().map(
      operator => ({
        ...operator,
        InputComponent: CustomFilters.DateInputValue
      })
    );

    columns[generatedFromDtColIndex] = {
      ...generatedFromDtColumn,
      filterOperators: generatedFromDtFilterOperators
    };

    const generatedToDtColumn = columns.find(
      column => column.field === columnFieldsName.generatedToDt
    );
    const generatedToDtColIndex = columns.findIndex(
      col => col.field === columnFieldsName.generatedToDt
    );

    const generatedToDtFilterOperators = getGridDateOperators().map(
      operator => ({
        ...operator,
        InputComponent: CustomFilters.DateInputValue
      })
    );

    columns[generatedToDtColIndex] = {
      ...generatedToDtColumn,
      filterOperators: generatedToDtFilterOperators
    };

    const purchaserNameFilterOperators = getGridStringOperators().map(
      operator => ({
        ...operator,
        InputComponent: CustomFilters.UserNameInputValue
      })
    );

    const supplierNameColumn = columns.find(
      column => column.field === columnFieldsName.bpName
    );
    const supplierNameColIndex = columns.findIndex(
      col => col.field === columnFieldsName.bpName
    );

    const supplierNameFilterOperators = getGridStringOperators().map(
      operator => ({
        ...operator,
        InputComponent: CustomFilters.SupplierVendorNameInputValue
      })
    );

    columns[supplierNameColIndex] = {
      ...supplierNameColumn,
      filterOperators: supplierNameFilterOperators
    };
  }

  const showDownloadPopUp = filePath => {
    const filePathReplaceWithDoubleBackwardSlash = filePath.replaceAll(
      "\\",
      "/"
    );
    const fileName = filePathReplaceWithDoubleBackwardSlash
      .split("/")
      [filePathReplaceWithDoubleBackwardSlash.split("/").length - 1].trim();
    fetch(
      `${process.env.REACT_APP_API_URL}/downloadFileFromServer?filePath=${filePathReplaceWithDoubleBackwardSlash}`,
      {
        method: "GET",
        headers: {
          authorization: "Bearer " + CommonService.getJwtTokenOfLoggedInUser()
        }
      }
    )
      .then(response => {
        return response.blob();
      })
      .then(blob => {
        setAlertBoxState({
          ...alertBoxState,
          openAlert: true,
          message: (
            <FormattedMessage
              id="successmessage.dowload"
              defaultMessage="File downloaded successfully"
            />
          ),
          severity: "success"
        });
        saveAs(blob, fileName);
      })
      .catch(error => {
        setAlertBoxState({
          ...alertBoxState,
          openAlert: true,
          message: (
            <FormattedMessage
              id="errorMessage.download"
              defaultMessage="Failed to download the file!"
            />
          ),
          severity: "error"
        });
      });
  };

  const showDownloadExcel = filePath => {
    const filePathReplaceWithDoubleBackwardSlash = filePath.replaceAll(
      "\\",
      "/"
    );
    const fileName = filePathReplaceWithDoubleBackwardSlash
      .split("/")
      [filePathReplaceWithDoubleBackwardSlash.split("/").length - 1].trim();
    fetch(
      `${process.env.REACT_APP_API_URL}/downloadFileFromServer?filePath=${filePathReplaceWithDoubleBackwardSlash}`,
      {
        method: "GET",
        headers: {
          authorization: "Bearer " + CommonService.getJwtTokenOfLoggedInUser()
        }
      }
    )
      .then(response => {
        return response.blob();
      })
      .then(blob => {
        setAlertBoxState({
          ...alertBoxState,
          openAlert: true,
          message: (
            <FormattedMessage
              id="successmessage.dowload"
              defaultMessage="File downloaded successfully"
            />
          ),
          severity: "success"
        });
        saveAs(blob, fileName);
      })
      .catch(error => {
        setAlertBoxState({
          ...alertBoxState,
          openAlert: true,
          message: (
            <FormattedMessage
              id="errorMessage.download"
              defaultMessage="Failed to download the file!"
            />
          ),
          severity: "error"
        });
      });
  };

  useEffect(() => {
    if (totalRowCount === 0) {
      setDisiablingDownloadButtonForZeroRecords(true);
    } else {
      setDisiablingDownloadButtonForZeroRecords(false);
    }
  }, [totalRowCount]);

  const filterableColumns = useMemo(() => GetFilterableColumns(columns), [
    columns
  ]);

  const key = "columnField";

  const applyFilter = () => {
    let bpName = null;
    let bpCode = null;
    let entityCode = null;
    let entityName = null;
    let msgStatusFlag = null;
    let poNumber = null;
    let msgStatusRemarks = null;
    let approvedBy = null;
    let approved = null;
    let generatedFromDt = null;
    let generatedToDt = null;
    //let ackStatusFlag = null;
    selectedFilters.map(columns => {
      switch (columns.columnField) {
        case "bpName":
          bpName = columns.value;
          break;
        case "msgStatusRemarks":
          msgStatusRemarks = columns.value;
          break;
        case "poNumber":
          poNumber = columns.value;
          break;
        case "msgStatusFlag":
          msgStatusFlag = columns.value;
          break;
        case "bpCode":
          bpCode = columns.value;
          break;
        case "approvedBy":
          approvedBy = columns.value;
          break;
        case "approved":
          approved = columns.value;
          break;
        case "generatedFromDt":
          generatedFromDt = columns.value;
          break;
        case "generatedToDt":
          generatedToDt = columns.value;
          break;
        case "entity.erpEntityCode":
          entityCode = columns.value;
          break;
        // case "ackStatusFlag":
        //   ackStatusFlag = columns.value;
        //   break;
      }
    });
    setSearchedApprovedRecords(approved);
    setSearchedBpCode(bpCode);
    setSearchedApprovedBy(approvedBy);
    setSearchedRemarks(msgStatusRemarks);
    setSearchedPoNo(poNumber);
    setSearchedErpEntityCode(entityCode);
    setSearchedBpName(bpName);
    setSearchedEmailStatus(msgStatusFlag);
    setSearchedGeneratedFromDt(generatedFromDt);
    setSearchedGeneratedToDt(generatedToDt);
    // setSearchedAckStatus(ackStatusFlag);
    savePreference(
      "filter",
      selectedFilters.length === 0 ? defaulSelectedFilters : selectedFilters
    );

    setParamBody(prevState => {
      return {
        ...prevState,
        body: {
          entity: {
            erpEntityCode: entityCode
          },
          msgStatusRemarks: msgStatusRemarks,
          bpCode: bpCode,
          bpName: bpName,
          poNumber: poNumber,
          msgStatusFlag:
            msgStatusFlag === "Not Sent"
              ? 0
              : msgStatusFlag === "Pending"
              ? 1
              : msgStatusFlag === "Successfully Sent"
              ? 2
              : msgStatusFlag === "Failed to Send"
              ? 3
              : msgStatusFlag === "Cancelled"
              ? 4
              : msgStatusFlag === "In-Queue"
              ? 6
              : msgStatusFlag === "In Progress"
              ? 7
              : "",
          createdDate: "",
          approvedBy: approvedBy,
          approved:
            approved === "Not Approved"
              ? 0
              : approved === "Approved"
              ? 1
              : approved === "Rejected"
              ? 2
              : "",
          apprEmailSent: true,
          recordApprovedStatus:
            approved === ""
              ? "All"
              : approved === "Not Approved"
              ? 0
              : approved === "Approved"
              ? 1
              : approved === "Rejected"
              ? 2
              : "All",
          recordApprSentStatus: "",
          recordEmailSentDate:
            searchedEmailStatusRecords === "EMAIL SENT"
              ? true
              : searchedEmailStatusRecords === "EMAIL NOT SENT"
              ? false
              : "",
          recordErrorStatus:
            msgStatusFlag === ""
              ? "All"
              : msgStatusFlag === "Not Sent"
              ? 0
              : msgStatusFlag === "Pending"
              ? 1
              : msgStatusFlag === "Successfully Sent"
              ? 2
              : msgStatusFlag === "Failed to Send"
              ? 3
              : msgStatusFlag === "Cancelled"
              ? 4
              : msgStatusFlag === "In-Queue"
              ? 6
              : msgStatusFlag === "In Progress"
              ? 7
              : "All",
          generatedFromDt: generatedFromDt,
          generatedToDt: generatedToDt
          // ackStatusFlag:
          // ackStatusFlag === "Not Sent"
          //   ? 0
          //   : ackStatusFlag === "Pending"
          //   ? 1
          //   : ackStatusFlag === "In-Progress"
          //   ? 2
          //   : ackStatusFlag === "Successfully sent"
          //   ? 3
          //   : "",
        }
      };
    });
  };

  useEffect(() => {
    if (intialParamBodyApiCall)
      setFilterCount(
        [...new Map(selectedFilters.map(item => [item[key], item])).values()]
          .length
      );
  }, [selectedFilters, tableData]);

  let filterBodyObj = {
    erpEntityCode: searchedErpEntityCode === null ? "" : searchedErpEntityCode,
    bpCode: searchedBpCode === "" ? null : searchedBpCode,
    approved:
      searchedApprovedRecords === "Not Approved"
        ? "NO"
        : searchedApprovedRecords === "Approved"
        ? "YES"
        : searchedApprovedRecords === "Rejected"
        ? "REJECTED"
        : null,
    // bpName: searchedBpName === "" ? null : searchedBpName,
    poNumber: searchedPoNo === "" ? null : searchedPoNo,
    approvedBy: searchedApprovedBy === "" ? null : searchedApprovedBy,
    msgStatusRemarks: searchedRemarks === "" ? null : searchedRemarks,
    msgStatusFlag: searchedEmailStatus === "" ? null : searchedEmailStatus,
    generatedFromDt:
      searchedGeneratedFromDt !== null ? searchedGeneratedFromDt : null,
    generatedToDt: searchedGeneratedToDt !== null ? searchedGeneratedToDt : null
    // ackStatusFlag: searchedAckStatus === "" ? null : searchedAckStatus,
  };

  useEffect(() => {
    let colValDataObj = {};
    for (let key in filterBodyObj) {
      let value = filterBodyObj[key];
      if (
        filterBodyObj.hasOwnProperty(key) &&
        (value !== null && value !== undefined && value !== {})
      ) {
        colValDataObj[key] = value.toString();
      }
      setKeyValueData(colValDataObj);
    }
  }, [
    searchedErpEntityCode,
    searchedBpCode,
    searchedApprovedBy,
    searchedBpName,
    searchedPoNo,
    searchedApprovedRecords,
    searchedRemarks,
    searchedEmailStatus,
    searchedGeneratedToDt,
    searchedGeneratedFromDt
  ]);

  return (
    <React.Fragment>
      <CssBaseline />
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={openAlert}
        onClose={handleCloseAlert}
        key={vertical + horizontal}
        autoHideDuration={6000}
      >
        <Alert onClose={handleCloseAlert} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
      <CommonBackDrop open={openBackDrop} />
      <Grid container className={classes.rootForOrder}>
        <Grid
          item
          container
          justifyContent="flex-start"
          alignItems="center"
          xs={12}
          sm={12}
          md={12}
          lg={12}
          className={classes.topGrid}
          style={{ marginLeft: "-0.5%" }}
        >
          <CustomBreadCrumb componentList={componentList} />
        </Grid>
        <Grid item container xs={12} sm={12} md={12} lg={12}>
          <CustomFilterComponent
            open={openFilterPanel}
            onClose={handleClose}
            filterableColumns={filterableColumns}
            setSelectedFilters={setSelectedFilters}
            selectedFilters={selectedFilters}
            applyFilter={applyFilter}
            defaulSelectedFilters={defaulSelectedFilters}
          />
          <ChipInfoList chipInfoList={chipInfoList} />
          <Paper
            elevation={3}
            className={classes.gridHeightAndWidthForPoTransmission}
          >
            <div style={{ height: "100%", width: "100%" }}>
              <DataGridPro
                className={classes.customTableStyle}
                sortingMode="server"
                rows={tableData}
                getRowId={row => row.poTransmissionHdrId}
                columns={columns}
                pageSize={paramBody.recordsPerPage}
                loading={tableLoadingStatus}
                rowCount={totalRowCount}
                scrollbarSize={30}
                disableColumnFilter={true}
                rowsPerPageOptions={[1, 2, 10, 25, 50, 100]}
                pagination
                density="compact"
                paginationMode="server"
                disableSelectionOnClick={true}
                disableColumnMenu={false}
                disableMultipleColumnsSorting={true}
                hideFooter={true}
                getDetailPanelContent={getDetailPanelContent}
                getDetailPanelHeight={getDetailPanelHeight}
                isRowSelectable={params =>
                  (params.row.approved === 1 &&
                    (params.row.msgStatusFlag === 0 ||
                      params.row.msgStatusFlag === 5 ||
                      params.row.msgStatusFlag === 1)) ||
                  (params.row.approved === 0 &&
                    params.row.msgStatusFlag === 5) ||
                  (params.row.approved === 2 &&
                    params.row.msgStatusFlag === 4 &&
                    (params.row.rejectionFlag === 1 ||
                      params.row.rejectionFlag === 2 ||
                      params.row.rejectionFlag === 3 ||
                      params.row.rejectionFlag === 4 ||
                      params.row.rejectionFlag === 5 ||
                      params.row.rejectionFlag === 11))
                    ? false
                    : true
                }
                // checkboxSelection
                onSelectionModelChange={currentlySelectedRow}
                selectionModel={selectedRow}
                localeText={localtext}
                onPageSizeChange={pageParams => {
                  setParamBody(prevState => {
                    return { ...prevState, recordsPerPage: pageParams };
                  });
                }}
                onPageChange={pageParams => {
                  setParamBody(prevState => {
                    return { ...prevState, pageNo: pageParams };
                  });
                }}
                pinnedColumns={pinnedColumns}
                onPinnedColumnsChange={params => {
                  var OrderedColumns = columns;
                  if (
                    pinnedColumns.left.length > params.left.length &&
                    pinnedColumns.right.length < params.right.length
                  ) {
                    var unpinnedColumns = pinnedColumns.left.filter(
                      x => params.left.indexOf(x) === -1
                    );
                    var index = OrderedColumns.findIndex(
                      element => element.field === unpinnedColumns[0]
                    );
                    var reOrderedColumns = OrderedColumns.splice(index, 1);
                    OrderedColumns.splice(
                      OrderedColumns.length,
                      0,
                      reOrderedColumns[0]
                    );
                  } else if (
                    pinnedColumns.right.length > params.right.length &&
                    pinnedColumns.left.length < params.left.length
                  ) {
                    var unpinnedColumns = pinnedColumns.right.filter(
                      x => params.right.indexOf(x) === -1
                    );
                    var index = OrderedColumns.findIndex(
                      element => element.field === unpinnedColumns[0]
                    );
                    var reOrderedColumns = OrderedColumns.splice(index, 1);
                    OrderedColumns.splice(
                      pinnedColumns.left.length - 1,
                      0,
                      reOrderedColumns[0]
                    );
                  } else if (pinnedColumns.left.length < params.left.length) {
                    var index = OrderedColumns.findIndex(
                      element =>
                        element.field === params.left[params.left.length - 1]
                    );
                    var reOrderedColumns = OrderedColumns.splice(index, 1);
                    OrderedColumns.splice(
                      pinnedColumns.left.length - 1,
                      0,
                      reOrderedColumns[0]
                    );
                  } else if (pinnedColumns.right.length < params.right.length) {
                    var index = OrderedColumns.findIndex(
                      element =>
                        element.field === params.right[params.right.length - 1]
                    );
                    var reOrderedColumns = OrderedColumns.splice(index, 1);
                    OrderedColumns.splice(
                      OrderedColumns.length,
                      0,
                      reOrderedColumns[0]
                    );
                  } else if (pinnedColumns.right.length > params.right.length) {
                    var unpinnedColumns = pinnedColumns.right.filter(
                      x => params.right.indexOf(x) === -1
                    );
                    var index = OrderedColumns.findIndex(
                      element => element.field === unpinnedColumns[0]
                    );
                    var reOrderedColumns = OrderedColumns.splice(index, 1);
                    OrderedColumns.splice(
                      -params.right.length,
                      0,
                      reOrderedColumns[0]
                    );
                  } else if (pinnedColumns.left.length > params.left.length) {
                    var unpinnedColumns = pinnedColumns.left.filter(
                      x => params.left.indexOf(x) === -1
                    );
                    var index = OrderedColumns.findIndex(
                      element => element.field === unpinnedColumns[0]
                    );
                    var reOrderedColumns = OrderedColumns.splice(index, 1);
                    OrderedColumns.splice(
                      params.left.length - 1,
                      0,
                      reOrderedColumns[0]
                    );
                  }
                  savePreference(
                    "pinned",
                    {
                      left: params.left,
                      right: params.right
                    },
                    OrderedColumns
                  );
                }}
                onColumnVisibilityChange={params => {
                  if (params.field !== "__check__") {
                    var visibleColumns = columns;
                    var index = visibleColumns.findIndex(
                      element => element.field === params.field
                    );
                    visibleColumns[index].hide = !params.isVisible;
                    savePreference("visibility", visibleColumns);
                  }
                }}
                onColumnOrderChange={params => {
                  --params.oldIndex;
                  --params.targetIndex;
                  var OrderedColumns = columns;
                  var reOrderedColumns = OrderedColumns.splice(
                    params.oldIndex,
                    1
                  );
                  OrderedColumns.splice(
                    params.targetIndex,
                    0,
                    reOrderedColumns[0]
                  );
                  savePreference("order", OrderedColumns);
                }}
                onSortModelChange={params => {
                  let sortModel = params[0];
                  var previousParamBody = paramBody;
                  if (
                    sortModel !== undefined &&
                    !(
                      previousParamBody.sortDir === sortModel.sort &&
                      previousParamBody.sortKey === sortModel.field
                    )
                  ) {
                    setParamBody({
                      ...paramBody,
                      sortDir: sortModel.sort,
                      sortKey: sortModel.field
                    });
                    savePreference("sort", params[0]);
                  } else if (
                    sortModel === undefined &&
                    !(
                      previousParamBody.sortDir === null &&
                      previousParamBody.sortKey === null
                    )
                  ) {
                    setParamBody({
                      ...paramBody,
                      sortDir: null,
                      sortKey: null
                    });
                    savePreference("sort", { field: null, sort: null });
                  }
                }}
                sortModel={[
                  {
                    field: paramBody.sortKey,
                    sort: paramBody.sortDir
                  }
                ]}
                sortingOrder={["desc", "asc"]}
                components={{
                  Toolbar: () => {
                    return (
                      <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        style={
                          mobileScreen
                            ? { marginBottom: "-0.1%", marginTop: "0%" }
                            : { marginBottom: "-0.3%", marginTop: "-0.5%" }
                        }
                      >
                        <Grid
                          item
                          container
                          direction="row"
                          justifyContent="flex-start"
                          xs={12}
                          sm={12}
                          md={6}
                          lg={6}
                        >
                          <Grid>
                            <Tooltip
                              title={
                                <FormattedMessage id="common.columntoolbar.tooltip" />
                              }
                              placement="bottom"
                            >
                              <GridToolbarColumnsButton
                                className={classes.toobarStyle}
                                variant="outlined"
                                size="medium"
                              />
                            </Tooltip>
                          </Grid>
                          <Grid>
                            <Tooltip
                              title={
                                <FormattedMessage id="common.density.tooltip" />
                              }
                              placement="bottom"
                            >
                              <GridToolbarDensitySelector
                                className={classes.toobarStyle}
                                variant="outlined"
                                size="medium"
                              />
                            </Tooltip>
                          </Grid>
                          <Grid>
                            <Tooltip
                              title={
                                <FormattedMessage id="common.toolbarfilterstooltipshow.toolbar.lable" />
                              }
                              placement="bottom"
                            >
                              <span>
                                <Button
                                  className={classes.refreshToobarStyle}
                                  variant="outlined"
                                  size="medium"
                                  onClick={() => setFilterPanel(true)}
                                >
                                  <Badge
                                    color="primary"
                                    badgeContent={filterCount}
                                  >
                                    <FilterList />
                                  </Badge>
                                </Button>
                              </span>
                            </Tooltip>
                          </Grid>
                          <Grid>
                            <Tooltip
                              title={
                                <FormattedMessage
                                  id="common.button.refresh.tooltip"
                                  defaultMessage="Refresh"
                                />
                              }
                              placement="bottom"
                            >
                              <span>
                                <Button
                                  size="small"
                                  color="primary"
                                  variant="outlined"
                                  className={classes.refreshToobarStyle}
                                  onClick={() => {
                                    setRefreshTable(!refreshTable);
                                    setSelectedRow([]);
                                    isDisableApproveButton(true);
                                    isDisableResendButton(true);
                                    isDisableRejectionButton(true);
                                  }}
                                >
                                  <RefreshIcon />
                                </Button>
                              </span>
                            </Tooltip>
                          </Grid>
                          {/* {!isBPVmi && (
                            <Grid>
                              <Tooltip
                                title={intl.formatMessage({
                                  id:
                                    "common.button.approveselectedrecords.tooltip"
                                })}
                                placement="bottom"
                              >
                                <span>
                                  {disableAuthorizationBasedOnTheRoleAccess && (
                                    <Button
                                      size="small"
                                      color="primary"
                                      variant="outlined"
                                      className={classes.refreshToobarStyle}
                                      onClick={onSubmit}
                                      disabled={
                                        disableApproveButton || isFormSubmitted
                                      }
                                    >
                                      {isRowSentForApproval ? (
                                        <CircularProgress
                                          color="secondary"
                                          size={20}
                                        />
                                      ) : (
                                        <IconApproval />
                                      )}
                                    </Button>
                                  )}
                                </span>
                              </Tooltip>
                            </Grid>
                          )} */}
                          {/* {!isBPVmi && (
                            <Grid>
                              <Tooltip
                                title={intl.formatMessage({
                                  id:
                                    "common.button.rejectselectedrecords.tooltip"
                                })}
                                placement="bottom"
                              >
                                <span>
                                  {disableAuthorizationBasedOnTheRoleAccess && (
                                    <Button
                                      size="small"
                                      color="primary"
                                      variant="outlined"
                                      className={classes.refreshToobarStyle}
                                      onClick={onSubmitReject}
                                      disabled={
                                        disableRejectionButton ||
                                        isFormSubmitted
                                      }
                                    >
                                      {isRowSentForRejection ? (
                                        <CircularProgress
                                          color="secondary"
                                          size={20}
                                        />
                                      ) : (
                                        <CancelIcon />
                                      )}
                                    </Button>
                                  )}
                                </span>
                              </Tooltip>
                            </Grid>
                          )} */}
                          {/* {!isBPVmi && (
                            <Grid>
                              <Tooltip
                                title={intl.formatMessage({
                                  id:
                                    "common.button.resendselectedrecords.tooltip"
                                })}
                                placement="bottom"
                              >
                                <span>
                                  {disableAuthorizationBasedOnTheRoleAccess && (
                                    <Button
                                      size="small"
                                      color="primary"
                                      variant="outlined"
                                      className={classes.refreshToobarStyle}
                                      onClick={onSubmitForResend}
                                      disabled={
                                        disableResendButton || isFormSubmitted
                                      }
                                    >
                                      {isRowSentForResend ? (
                                        <CircularProgress
                                          color="secondary"
                                          size={20}
                                        />
                                      ) : (
                                        <ResendIcon />
                                      )}
                                    </Button>
                                  )}
                                </span>
                              </Tooltip>
                            </Grid>
                          )} */}
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                          <CommonGridPagination />
                        </Grid>
                      </Grid>
                    );
                  },

                  FilterPanel: () => {
                    return (
                      <Grid container direction="row">
                        <Grid
                          container
                          item
                          justifyContent="flex-start"
                          alignItems="center"
                          xs={6}
                          sm={6}
                          md={6}
                          lg={6}
                        >
                          <GridFilterPanel />
                        </Grid>
                        <Grid
                          container
                          item
                          justifyContent="flex-end"
                          alignItems="flex-end"
                          xs={6}
                          sm={6}
                          md={6}
                          lg={6}
                          style={{ marginLeft: "-24%" }}
                        >
                          <Button
                            color="primary"
                            style={{ paddingBottom: "10px" }}
                            onClick={() => {
                              setParamBody(prevState => {
                                return {
                                  ...prevState,
                                  body: {
                                    entity: {
                                      erpEntityCode: searchedErpEntityCode
                                    },
                                    msgStatusRemarks: searchedRemarks,
                                    bpCode: searchedBpCode,
                                    bpName: searchedBpName,
                                    poNumber: searchedPoNo,
                                    msgStatusFlag: searchedEmailStatus,
                                    createdDate: "",
                                    approvedBy: searchedApprovedBy,
                                    approved:
                                      searchedApprovedRecords === ""
                                        ? "All"
                                        : searchedApprovedRecords,
                                    apprEmailSent: true,
                                    recordApprovedStatus:
                                      searchedApprovedRecords === ""
                                        ? "All"
                                        : searchedApprovedRecords,
                                    recordApprSentStatus: "",
                                    recordEmailSentDate:
                                      searchedEmailStatusRecords ===
                                      "EMAIL SENT"
                                        ? true
                                        : searchedEmailStatusRecords ===
                                          "EMAIL NOT SENT"
                                        ? false
                                        : "",
                                    recordErrorStatus:
                                      searchedEmailStatus === ""
                                        ? "All"
                                        : searchedEmailStatus,
                                    generatedFromDt:
                                      searchedGeneratedFromDt !== null
                                        ? searchedGeneratedFromDt.substr(1, 10)
                                        : null,
                                    generatedToDt:
                                      searchedGeneratedToDt !== null
                                        ? searchedGeneratedToDt.substr(1, 10)
                                        : null
                                    // ackStatusFlag: searchedAckStatus,
                                  }
                                };
                              });
                            }}
                          >
                            <FormattedMessage id="common.applyfilter.lable" />
                          </Button>
                        </Grid>
                      </Grid>
                    );
                  }
                }}
                sortingOrder={["desc", "asc"]}
                filterMode="server"
                onFilterModelChange={async params => {
                  let filterModelItem = params.items;
                  if (filterModelItem.length > 0) {
                    let approved = null;
                    let bpCode = null;
                    let bpName = null;
                    let approvedBy = null;
                    let msgStatusRemarks = null;
                    let poNumber = null;
                    let erpEntityCode = null;
                    let msgStatusFlag = null;
                    let generatedFromDt = null;
                    let generatedToDt = null;
                    let ackStatusFlag = null;
                    for (
                      let index = 0;
                      index < filterModelItem.length;
                      index++
                    ) {
                      if (
                        filterModelItem[index].columnField ===
                        columnFieldsName.erpEntityCode
                      ) {
                        erpEntityCode =
                          (await filterModelItem[index].value) === undefined
                            ? ""
                            : JSON.parse(filterModelItem[index].value)
                                .erpEntityCode;
                        break;
                      }
                    }
                    for (
                      let index = 0;
                      index < filterModelItem.length;
                      index++
                    ) {
                      if (
                        filterModelItem[index].columnField ===
                        columnFieldsName.approved
                      ) {
                        approved =
                          (await filterModelItem[index].value) === undefined
                            ? ""
                            : JSON.parse(filterModelItem[index].value).value;
                        break;
                      }
                    }
                    for (
                      let index = 0;
                      index < filterModelItem.length;
                      index++
                    ) {
                      if (
                        filterModelItem[index].columnField ===
                        columnFieldsName.msgStatusFlag
                      ) {
                        msgStatusFlag =
                          (await filterModelItem[index].value) === undefined
                            ? ""
                            : JSON.parse(filterModelItem[index].value).value;
                        break;
                      }
                    }
                    for (
                      let index = 0;
                      index < filterModelItem.length;
                      index++
                    ) {
                      if (
                        filterModelItem[index].columnField ===
                        columnFieldsName.bpCode
                      ) {
                        bpCode =
                          (await filterModelItem[index].value) === undefined
                            ? ""
                            : filterModelItem[index].value;
                        break;
                      }
                    }
                    for (
                      let index = 0;
                      index < filterModelItem.length;
                      index++
                    ) {
                      if (
                        filterModelItem[index].columnField ===
                        columnFieldsName.bpName
                      ) {
                        bpName =
                          (await filterModelItem[index].value) === undefined
                            ? ""
                            : filterModelItem[index].value;
                        break;
                      }
                    }
                    for (
                      let index = 0;
                      index < filterModelItem.length;
                      index++
                    ) {
                      if (
                        filterModelItem[index].columnField ===
                        columnFieldsName.msgStatusRemarks
                      ) {
                        msgStatusRemarks =
                          (await filterModelItem[index].value) === undefined
                            ? ""
                            : filterModelItem[index].value;
                        break;
                      }
                    }
                    for (
                      let index = 0;
                      index < filterModelItem.length;
                      index++
                    ) {
                      if (
                        filterModelItem[index].columnField ===
                        columnFieldsName.approvedBy
                      ) {
                        approvedBy =
                          (await filterModelItem[index].value) === undefined
                            ? ""
                            : filterModelItem[index].value;
                        break;
                      }
                    }
                    for (
                      let index = 0;
                      index < filterModelItem.length;
                      index++
                    ) {
                      if (
                        filterModelItem[index].columnField ===
                        columnFieldsName.generatedFromDt
                      ) {
                        generatedFromDt = await (filterModelItem[index]
                          .value !== undefined &&
                        filterModelItem[index].value !== null &&
                        filterModelItem[index].value !== "null"
                          ? filterModelItem[index].value
                          : null);
                        break;
                      }
                    }
                    for (
                      let index = 0;
                      index < filterModelItem.length;
                      index++
                    ) {
                      if (
                        filterModelItem[index].columnField ===
                        columnFieldsName.generatedToDt
                      ) {
                        generatedToDt = await (filterModelItem[index].value !==
                          undefined &&
                        filterModelItem[index].value !== null &&
                        filterModelItem[index].value !== "null"
                          ? filterModelItem[index].value
                          : null);
                        break;
                      }
                    }
                    setSearchedApprovedRecords(approved);
                    setSearchedBpCode(bpCode);
                    setSearchedApprovedBy(approvedBy);
                    setSearchedRemarks(msgStatusRemarks);
                    setSearchedPoNo(poNumber);
                    setSearchedErpEntityCode(erpEntityCode);
                    setSearchedBpName(bpName);
                    setSearchedEmailStatus(msgStatusFlag);
                    setSearchedGeneratedFromDt(generatedFromDt);
                    setSearchedGeneratedToDt(generatedToDt);
                    setSearchedAckStatus(ackStatusFlag);
                  }
                }}
              />
            </div>
          </Paper>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default PoTransmissionHdr;
